import {
  transformAssessmentsAuthConfig,
  transformAssessmentsQuestionsResponse,
  transformVerifyUserResponse,
} from 'features/assessments/utils/apiDataTransformUtils';
import {
  AssessmentAuthenticationFields,
  AssessmentsSaveAnswerRequest,
  AssessmentsSaveAnswerResponse,
  AssessmentsAnswersResponse,
  AssessmentsVerifyUserRequest,
  AssessmentDetails,
  AssessmentsQuestionnaireViewModel,
} from 'features/assessments/types';
import { AssessmentsApi } from 'store/assessmentsApi';

export const assessmentsService = AssessmentsApi.injectEndpoints({
  endpoints: (builder) => ({
    getAssessmentsAuthenticationFields: builder.query<AssessmentAuthenticationFields, string>({
      query: (tenantId: string) => ({
        url: `/mobileapi/v1/assessments/fhir-configuration`,
        headers: {
          'X-TENANT-ID': tenantId,
        },
      }),
      transformResponse: transformAssessmentsAuthConfig,
    }),
    getAssessmentsQuestions: builder.query<
      AssessmentsQuestionnaireViewModel,
      {
        surveyId: string;
        tenantId: string;
      }
    >({
      query: ({ surveyId, tenantId }) => ({
        url: `/mobileapi/v1/assessments/${surveyId}/survey`,
        headers: {
          'X-TENANT-ID': tenantId,
        },
      }),
      transformResponse: transformAssessmentsQuestionsResponse,
    }),
    saveAssessmentsAnswers: builder.mutation<
      AssessmentsSaveAnswerResponse,
      {
        tenantId: string;
        requestBody: AssessmentsSaveAnswerRequest;
      }
    >({
      query: ({ tenantId, requestBody }) => ({
        url: `/mobileapi/v1/assessments/survey-answers`,
        method: 'POST',
        headers: {
          'X-TENANT-ID': tenantId,
        },
        body: requestBody,
      }),
    }),
    getAssessmentsAnswers: builder.query<
      AssessmentsAnswersResponse,
      {
        tenantId: string;
        surveyId: string;
        activityId: string;
      }
    >({
      query: ({ tenantId, surveyId, activityId }) => ({
        url: `/mobileapi/v1/assessments/${surveyId}/${activityId}/surveyAnswers`,
        headers: {
          'X-TENANT-ID': tenantId,
        },
      }),
    }),
    verifyAssessmentsUser: builder.mutation<
      AssessmentDetails,
      {
        tenantId: string;
        requestBody: AssessmentsVerifyUserRequest;
      }
    >({
      query: ({ tenantId, requestBody }) => ({
        url: `/mobileapi/v1/assessments/assessment-access`,
        headers: {
          'X-TENANT-ID': tenantId,
        },
        method: 'POST',
        body: requestBody,
      }),
      transformResponse: transformVerifyUserResponse,
    }),
  }),
});

export const {
  useGetAssessmentsAuthenticationFieldsQuery,
  useGetAssessmentsQuestionsQuery,
  useSaveAssessmentsAnswersMutation,
  useLazyGetAssessmentsAnswersQuery,
  useVerifyAssessmentsUserMutation,
} = assessmentsService;
